import { Link } from '@react-email/components';
import { getLinkSesTags } from '@Utils/general';

const link = {
    EditorElement: props => {
        const { attributes, children, element } = props;

        return (
            <Link
                {...attributes}
                {...element.attributes}
                style={{ color: undefined }}
            >
                {children}
            </Link>
        );
    },
    PreviewElement: ({ editor, node, originalNode, attributes, children }) => {
        return (
            <Link
                {...attributes}
                style={{ color: undefined }}
                {...getLinkSesTags(editor, originalNode)}
            >
                {children}
            </Link>
        );
    },
};

export default link;
